// src/components/AuthenticatedLayout.jsx
import React from 'react';
import Sidebar from './Sidebar/Sidebar';

const AuthenticatedLayout = ({ children }) => {
  return (
    <div className='authenticated-layout'>
      <Sidebar />
      <div className='main-content'>{children}</div>
    </div>
  );
};

export default AuthenticatedLayout;
